import React from "react";
import { get, uniq, filter } from "lodash";

export default function AllergiesTile({ model }) {
  const allergies = get(model, "allergies", []) || [];
  const allergiesByType = uniq(allergies.map((allergy) => allergy.type)).map(
    (type) => ({
      type,
      allergies: filter(allergies, { type }),
    }),
  );
  const nka = allergies.length === 1 && allergies[0].type === "NKA";
  const status = nka
    ? "nka"
    : allergies.length
      ? "has-allergies"
      : "not-entered";
  return (
    <React.Fragment>
      <div className={`title ${status}`}>
        Allergies
        {allergies.length && !nka ? (
          <span className="count">{allergies.length}</span>
        ) : null}
      </div>
      <div className={`allergies tile-content ${status}`}>
        {allergies.length ? (
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Allergy</th>
                <th>Reaction</th>
              </tr>
            </thead>
            <tbody>
              {allergiesByType.map((allergyType, i) =>
                allergyType.allergies.map((allergy, j) => (
                  <tr key={`${i}-${j}`}>
                    {j === 0 ? (
                      <td
                        className="type"
                        rowSpan={allergyType.allergies.length}
                      >
                        {allergy.type}
                      </td>
                    ) : null}
                    <td className="allergy">{allergy.name}</td>
                    <td className="reaction">{allergy.reaction}</td>
                  </tr>
                )),
              )}
            </tbody>
          </table>
        ) : (
          <div className="no-data">Allergies not entered</div>
        )}
      </div>
    </React.Fragment>
  );
}
